import React, { useMemo } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import { useTranslation } from 'react-i18next';
import TierManageContent from '@wix/da-shared-react/pkg/Tier/TierManageContent';
import UnderlinedTabs from '@wix/da-ds/pkg/Tabs/dsPresets/UnderlinedTabs';
import { SubscriptionsTierContentType } from '../../../../types/subscriptionsSection';
import TierContentFeed from './TierContentFeed';
import TiersDropdown from './TiersDropdown';

import s from './TierContent.scss';

export interface Props {
  isOwner: boolean;
  moduleId: number;
  streamId: string;
  tier?: PapiDeviation;
  isEmpty?: boolean;
  selectedTierContentType: SubscriptionsTierContentType;
  setSelectedTierContentType: (type: SubscriptionsTierContentType) => void;
}

const TierContent: React.FC<Props> = ({
  isOwner,
  tier,
  streamId,
  selectedTierContentType,
  setSelectedTierContentType,
}) => {
  const { t } = useTranslation();

  const tabs = useMemo(
    () => [
      {
        index: SubscriptionsTierContentType.DEVIATIONS,
        label: t('widgets.tierContent.tabs.deviations'),
      },
      {
        index: SubscriptionsTierContentType.POSTS,
        label: t('widgets.tierContent.tabs.posts'),
      },
    ],
    [t]
  );

  if (!tier) {
    return null;
  }
  return (
    <div className={s['root']}>
      <div className={s['toolbar']}>
        <TiersDropdown className={s['title']} />
        <UnderlinedTabs
          className={s['tabs']}
          items={tabs}
          activeIndex={selectedTierContentType}
          onChange={tab =>
            setSelectedTierContentType(tab as SubscriptionsTierContentType)
          }
        />

        <div className={s['buttons']}>
          {isOwner && (
            <>
              <TierManageContent type={'deviation'} tierDeviation={tier} />
              <TierManageContent type={'post'} tierDeviation={tier} />
            </>
          )}
        </div>
      </div>
      <div className={s['content']}>
        <TierContentFeed
          streamId={streamId}
          tierContentType={selectedTierContentType}
        />
      </div>
    </div>
  );
};
TierContent.displayName = 'TierContent';

export default TierContent;
